import "./view-tools.component.scoped.sass";
import React from "react";
import { ViewToolsProps } from "../../types/view-tools-props";
import { TableToolsComponent } from "../table-tools/table-tools.component";
import { CalendarToolsComponent } from "../calendar-tools/calendar-tools.component";
import { useTranslation } from "react-i18next";

export const ViewToolsComponent = (props: ViewToolsProps) => {
  const { mode, options, tools, title, total } = props;
  const [t] = useTranslation();
  return (
    <div className="view-tools">
      <div className="table-head">
        <div className="table-title"> { t(title) } </div>
        <div className="total"> {total} {t("results")}</div>
      </div>
      <div>
        {mode === "table" ? (
          <TableToolsComponent options={options} tools={tools} />
        ) : (
          <CalendarToolsComponent options={options} />
        )}
      </div>
    </div>
  );
};
